import React, { useState, useEffect, useRef } from 'react'
// import * as Sentry from "@sentry/browser";
// import 'tinymce/tinymce'
// import 'tinymce/icons/default'
// import 'tinymce/themes/silver'
// import 'tinymce/plugins/advlist'
// import 'tinymce/plugins/autolink'
// import 'tinymce/plugins/lists'
// import 'tinymce/plugins/link'
// import 'tinymce/plugins/image'
// import 'tinymce/plugins/charmap'
// import 'tinymce/plugins/print'
// import 'tinymce/plugins/preview'
// import 'tinymce/plugins/anchor'
// import 'tinymce/plugins/searchreplace'
// import 'tinymce/plugins/visualblocks'
// import 'tinymce/plugins/code'
// import 'tinymce/plugins/fullscreen'
// import 'tinymce/plugins/insertdatetime'
// import 'tinymce/plugins/media'
// import 'tinymce/plugins/table'
// import 'tinymce/plugins/paste'

// import 'tinymce/plugins/help'
// import 'tinymce/plugins/wordcount'

// import 'tinymce/plugins/noneditable'
// import 'tinymce/plugins/paste'
// import 'tinymce/plugins/link'
// import 'tinymce/plugins/image'
// import 'tinymce/plugins/table'
// import 'tinymce/skins/ui/oxide/skin.min.css'
// import 'tinymce/skins/ui/oxide/content.min.css'
// import 'tinymce/skins/content/default/content.min.css'
import { Editor } from '@tinymce/tinymce-react'
import { injectIntl } from 'react-intl'
import {
  Row,
  Card,
  CardBody,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from 'reactstrap'
import { AvForm } from 'availity-reactstrap-validation'
// import LanguageDetect from 'languagedetect'
// import { franc } from 'franc'
import isEmpty from 'lodash.isempty'
import { useLocation, useHistory } from "react-router-dom"
// import remove from 'lodash.remove'
import { Colxx } from '../../../components/common/CustomBootstrap'
import IntlMessages from '../../../helpers/IntlMessages'
import 'react-tagsinput/react-tagsinput.css'
// import 'react-quill/dist/quill.snow.css'
// import 'react-quill/dist/quill.bubble.css'
import StateButton from '../../../components/common/StateButton'
import { NotificationManager } from '../../../components/common/react-notifications'
import RephraseTools from './RephraseTools'
import {
  removeInvalidTags, getPhrasesToParaphrase, getDomainOrigin, paraphraseSentence
} from './utilsCreate'

const axios = require('axios')

const Promise = require('bluebird')
const cheerio = require('cheerio')


const {
  addHighlightedParaphrase, diffTextOnChangeText, copyTextToClipboard, rephraseSentence, undoPhrase,
  copyParaphraseToClipboard, addSynonymsList, removeSynonymsList, removeRephraseTools, fixEntityEncoding
} = require('./utils')

let initialValueOriginal = ''
const initialValueParaphrased = ''

// esse objeto é necessário para passar os synonyms para dentro do tiny
// se fosse um estado do react não funcionaria
let synonyms2 = {}
let trial2 = {}
let usuarioPagante2 = {}

let totalParagraphsToRewrite = 0
let totalParagraphsRewrited = 0

function EditorsParaphrase(props) {
  const { messages } = props.intl
  const history = useHistory()

  const location = useLocation()
  const summarizedText = location?.state?.text

  const {
    tool = 'synonymous'
  } = props

  const [modalBack, setModalBack] = useState(false)
  const toggleModalBack = () => { setModalBack(!modalBack) }
  const [modalBackIP, setModalBackIP] = useState(false)
  const toggleModalBackIPVazio = () => { setModalBackIP(!modalBackIP) }

  const [spanCursor] = useState('<span id="cursor" class="added"></span>')

  const [paraphrases, setParaphrases] = useState([])
  const [synonymsRephrase, setSynonymsRephrase] = useState({})

  const editorOriginal = useRef(null)
  const editorParaphrased = useRef(null)

  const [showButtonParaphrase, setShowButtonParaphrase] = useState(false)

  const [classEditorOriginal, setClassEditorOriginal] = useState('')
  const [classEditorParaphrase, setClassEditorParaphrase] = useState('d-none d-md-block')

  const [synonyms, setSynonyms] = useState({})
  const [trial, setTrial] = useState(false)
  const [ip, setIP] = useState('')
  let ip2 = 0
  const [email, setEmail] = useState('')
  let email2 = ''
  const [userID, setUserID] = useState('')
  let userID2 = 0
  const [usuarioPagante, setUsuarioPagante] = useState(false)

  const [planoAtivoCliente, setPlanoAtivoCliente] = useState({})
  // const [geolocation, setGeolocation] = useState('');

  const [socketIsPaused, setSocketPause] = useState(false);

  
  // const [totalParagraphsToRewrite, setTotalParagraphsToRewrite] = useState(0)
  // const [totalParagraphsRewrited, setTotalParagraphsRewrited] = useState(0)

  const formRef = useRef(null)

  const [ws, setWs] = useState(null);
  // const clientRef = useRef(null);


  const clientRef = useRef(null);
  const [waitingToReconnect, setWaitingToReconnect] = useState(null);
  const [messagesSocket, setMessagesSocket] = useState([]);
  const [isOpen, setIsOpen] = useState(false);

  function addMessage(message) {
    setMessagesSocket([...messagesSocket, message]); 
  }

  useEffect(() => {

    if (waitingToReconnect) {
      return;
    }

    // Only set up the websocket once
    if (!clientRef.current) {
      const client = new WebSocket('wss://13cc59ad5m.execute-api.us-east-1.amazonaws.com/dev');
      clientRef.current = client;

      window.client = client;

      client.onerror = (e) => console.error(e);

      client.onopen = () => {
        setIsOpen(true);
        // console.log('ws opened');
        // client.send('ping');
      };

      client.onclose = () => {

        if (clientRef.current) {
          // Connection failed
          // console.log('ws closed by server');
        } else {
          // Cleanup initiated from app side, can return here, to not attempt a reconnect
          // console.log('ws closed by app component unmount');
          return;
        }

        if (waitingToReconnect) {
          return;
        };

        // Parse event code and log
        setIsOpen(false);
        // console.log('ws closed');

        // Setting this will trigger a re-run of the effect,
        // cleaning up the current websocket, but not setting
        // up a new one right away
        setWaitingToReconnect(true);

        // This will trigger another re-run, and because it is false,
        // the socket will be set up again
        setTimeout(() => setWaitingToReconnect(null), 5000);
      };

      client.onmessage = event => {
        // console.log('received message', event);
        addMessage(`received '${event.data}'`);

        if (event.data
          && (JSON.parse(event.data).message === "Internal server error"
          || JSON.parse(event.data).message === "Endpoint request timed out")) {
            // console.log('CAIU AQUI')
            // setWaitingToReconnect(null)
          return
        }

        onGetRewritedText(event.data, userID2, email2, ip2)
        return ''
      };


      return () => {

        clientRef.current = null;

        client.close();
      }
    }

  }, [waitingToReconnect]);

  useEffect(() => { trial2 = trial }, [trial])
  useEffect(() => { usuarioPagante2 = usuarioPagante }, [usuarioPagante])

  useEffect(() => {
    if (formRef.current) {
      setShowButtonParaphrase(true)
    }
  }, [formRef])

  useEffect(() => {
    synonyms2 = Object.assign({}, synonyms2, synonymsRephrase)
  }, [synonymsRephrase])

  useEffect(() => {
    synonyms2 = synonyms
  }, [synonyms])

  useEffect(() => {
    if (!isEmpty(summarizedText)) initialValueOriginal = summarizedText
  }, [summarizedText])

  useEffect(() => {
    const email = window.location.pathname.split('app/paraphrase2/')[1]
    // console.log('email:', email)
    setEmail(email || '')
    email2 = email

    async function fetchData() {
      // SE EM ALGUM MOMENTO PARAR DE FUNCIONAR, VER A LISTA NESSE SITE
      // https://stackoverflow.com/questions/391979/how-to-get-clients-ip-address-using-javascript

      const intervalId = setInterval(async () => {
        try {
          await axios.get('https://ipapi.co/json/', { timeout: 3000 })
          .then((response) => {
            console.log('https://ipapi.co/json/', response.data.ip)
            if ((isEmpty(ip) || ip === "Not found")) {
              setIP(response.data.ip)
              ip2 = response.data.ip
              clearInterval(intervalId);
            }
          })
        } catch (error) {
          console.log("error: ", error);
        }

        try {
          await axios.get('https://api.ipregistry.co/?key=tryout', { timeout: 3000 })
          .then((response) => {
            console.log('https://api.ipregistry.co/?key=tryout', response.data.ip)
            if ((isEmpty(ip) || ip === "Not found")) {
              setIP(response.data.ip)
              ip2 = response.data.ip
              clearInterval(intervalId);
            }
          })
        } catch (error) {
          console.log("error: ", error);
        }

        try {
          await axios.get('https://geolocation-db.com/json/', { timeout: 3000 })
          .then((response) => {
            // console.log('https://geolocation-db.com/json/', response.data.IPv4 || response.data.IPv6)
            if ((isEmpty(ip) || ip === "Not found")) {
              setIP(response.data.IPv4 || response.data.IPv6)
              ip2 = response.data.IPv4 || response.data.IPv6
              clearInterval(intervalId);
            }
          })
        } catch (error) {
          console.log("error: ", error);
        }

        try {
          await axios.get('https://icanhazip.com/', { timeout: 3000 })
          .then((response) => {
            // console.log('https://icanhazip.com/', response.data)
            if ((isEmpty(ip) || ip === "Not found")) {
              if ((isEmpty(response.data) || response.data === "Not found")) {
                setIP(response.data)
                ip2 = response.data
              }
              clearInterval(intervalId);
            }
          })
        } catch (error) {
          console.log("error: ", error);
        }


      }, 1000);

      if (isEmpty(email) || email === undefined || email === 'undefined') {
        setTrial(true)
        return
      }

      await axios.get(`https://reescrever.app/wp-json/api/v1/dados/subscription2/${email}`)
        .then((response) => {
          response.data.forEach((pag) => {
            const {
              plano, data, status, userID, code
            } = pag

            setUserID(userID)
            userID2 = userID

            const date = new Date(parseInt(data) * 1000)
            const date2 = new Date()

            const diffMinute = Math.ceil(Math.abs(date2 - date) / 60000)

            if ((plano === 'Grátis' || isEmpty(plano)) && usuarioPagante2 === false) setTrial(true)
            else if (['Semana Reescrever',
              'Mensal Reescrever',
              'Trimestral Reescrever',
              'Semestral Reescrever',
              'Anual Reescrever',
              'Semana Resumir + Reescrever',
              'Mensal Resumir + Reescrever',
              'Trimestral Resumir + Reescrever',
              'Semestral Resumir + Reescrever',
              'Anual Resumir + Reescrever'
            ].includes(plano) && status !== 'refunded') {

              if (
                ((plano === 'Semana Reescrever' || plano === 'Semana Resumir + Reescrever')
                  && diffMinute < 10080)
                  || ((plano === 'Mensal Reescrever' || plano === 'Mensal Resumir + Reescrever')
                  && diffMinute < 44640)
                  || ((plano === 'Trimestral Reescrever' || plano === 'Trimestral Resumir + Reescrever')
                  && diffMinute < 133920)
                  || ((plano === 'Semestral Reescrever' || plano === 'Semestral Resumir + Reescrever')
                  && diffMinute < 267840)
                  || ((plano === 'Anual Reescrever' || plano === 'Anual Resumir + Reescrever')
                  && diffMinute < 527040)
              ) {
                setUsuarioPagante(true)
              }

            } else if (['Semana Resumir',
              'Mensal Resumir',
              'Trimestral Resumir',
              'Semestral Resumir',
              'Anual Resumir'
            ].includes(plano) && status !== 'refunded') {

              if (
                (plano === 'Semana Resumir' && diffMinute < 10080)
                || (plano === 'Mensal Resumir' && diffMinute < 44640)
                || (plano === 'Trimestral Resumir' && diffMinute < 133920)
                || (plano === 'Semestral Resumir' && diffMinute < 267840)
                || (plano === 'Anual Resumir' && diffMinute < 527040)
              ) {
                setPlanoAtivoCliente(pag)
              }
            }
          })
        })
        .catch(() => { setTrial(true) })
    }

    fetchData()
  }, [])

  const delay = ms => new Promise(res => setTimeout(res, ms));

  const onSubmitText = async (text) => {
    // console.log('onSubmitText:', text)
    NotificationManager.remove(NotificationManager.listNotify[0])
    
    
      if (trial) {
        var maxLength = 300;
        var words = text.split(/\s+/);
        var slicedWords = words.slice(0, maxLength);
        text = slicedWords.join(' ');
      }
      if (trial === false) {
        var maxLength = 2000;
        var words = text.split(/\s+/);
        var slicedWords = words.slice(0, maxLength);
        text = slicedWords.join(' ');
      }
    
    const html = removeInvalidTags(text)
    let paragraphs = getPhrasesToParaphrase(html, trial)
    

    // remove itens vazios do array
    console.log("paragraphs: ", paragraphs);
    paragraphs = paragraphs.filter((n) => n)

    totalParagraphsToRewrite = paragraphs.length

    // paragraphs = paragraphs.map(paragraph => { if(!isEmpty(paragraph)) return paragraph })
    console.log("paragraphs: ", paragraphs);

    if (paragraphs.length === 0) {
      NotificationManager.info('Não foi encontrado parágrafos, somente "títulos". Caso deseja reescrever o texto adicionado no programa, altere-o para "parágrafo".', '', 0)
      return
    }

    NotificationManager.info(messages['Your paraphrased text is being generated'], '', 0)

    editorParaphrased.current.dom.addClass(editorParaphrased.current.dom.select('body'), 'rewriting');
    editorParaphrased.current.setContent(text)

    if (usuarioPagante === true) {
      // NÃO VERIFICA IP, POIS O USUÁRIO JÁ É PAGANTE
    } else if ((isEmpty(ip) || ip === "Not found")) {
      console.log('ERRO DESCONHECIDO')

      let counter = 0
      const intervalId = setInterval(async () => {
        counter++;
        console.log(counter, 'segundo')

        await axios.get('https://geolocation-db.com/json/', { timeout: 3000 })
          .then((response) => {
            console.log('https://geolocation-db.com/json/', response.data.IPv4 || response.data.IPv6)
            if ((isEmpty(ip) || ip === "Not found")) {
              setIP(response.data.IPv4 || response.data.IPv6)
              ip2 = response.data.IPv4 || response.data.IPv6
              clearInterval(intervalId);
            }
          })

        await axios.get('https://icanhazip.com/', { timeout: 3000 })
          .then((response) => {
            console.log('https://icanhazip.com/', response.data)
            if ((isEmpty(ip) || ip === "Not found")) {
              if ((isEmpty(response.data) || response.data === "Not found")) {
                setIP(response.data)
                ip2 = response.data
              }
              clearInterval(intervalId);
            }
          })

        // ESPERA 5 SEGUNDOS ANTES DE NÃO EXECUTAR MAIS
        if (counter >= 5) {
          clearInterval(intervalId)
          if ((isEmpty(ip) || ip === "Not found")) window.parent.location.href = "https://reescrever.app/erro-desconhecido/";
        }
      }, 1000);

      await delay(5000);
    } else if (usuarioPagante === false && trial === false) {
      // Se cair aqui, então é porque o usuário pagou apenas o reescrever, não o resumir
      // console.log('planoAtivoCliente', JSON.stringify(planoAtivoCliente, null, 2))
      const {
        plano, gateway, code
      } = planoAtivoCliente

      // console.log('plano', plano)
      
      const upgradePlans = ["Mensal Resumir", "Trimestral Resumir", "Semestral Resumir", "Anual Resumir"];

      if (plano === "Semana Resumir" || gateway === 'check') {
        // Pode comprar o plano semana ou assinar plano mensal / trimestral
        window.parent.location.href = `https://reescrever.app/precos-reescrever`;
      } else if (upgradePlans.includes(plano)) {
        // mostra valor pro-rata para o cliente pagar diferença e altera para do tipo plano resumir + reescrever
        window.parent.location.href = `https://reescrever.app/upgrade/?code=${code}`;
      } else {
        // Não possui nenhum plano ativo
        window.parent.location.href = `https://reescrever.app/precos/#reescrever`;
      }

    }

    // VERIFICA SE O USUÁRIO JÁ FEZ 1 TEXTO GRÁTIS NO DIA
    // console.log('trial1:', trial)
    if (trial) {
      // console.log('trial2:', trial)
      let usoGratisDisponivel = true
      // console.log('ip:', ip)
      await axios.post(`https://q1f8kd88uc.execute-api.us-east-1.amazonaws.com/prod/daily-use`, { ip })
        .then((response) => {
          // console.log('response.data:', response.data)
          // if (response && response.data && response.data !== "" && response.data >= 1) {
          if (response && response.data && response.data === "disallow") {
            usoGratisDisponivel = false
            window.parent.location.href = "https://reescrever.app/limite-de-uso/";
          }
        })

      if (usoGratisDisponivel === false) return
    }

    
    
    if (clientRef.current) {
      paragraphs.forEach(paragraph => {
        console.log("paragraph: ", paragraph);
        if (!isEmpty(paragraph)) clientRef.current.send(JSON.stringify({ text: paragraph }));
      })
    }

    // let sentencesList = await axios.post(`${getDomainOrigin()}/paraphrase/sentences`, { phrases })
    //   .then((response) => response.data)
    //   .catch(async (err) => { console.log('ERRO', err) })

    // let countWords = 0
    // sentencesList = sentencesList.map(sentence => {
    //   if (trial && countWords < 300) {
    //     countWords += sentence.split(' ').length
    //     return sentence
    //   }
    //   if (trial === false && countWords < 2000) {
    //     countWords += sentence.split(' ').length
    //     return sentence
    //   }
    // })
    // sentencesList = sentencesList.filter((n) => !isEmpty(n)) // remove itens vazios do array

    // setSynonyms({})

    // const sentencesNoRewrited = []
    // Promise.map(sentencesList, async (sentence) => {
    //   setClassEditorOriginal('d-none d-md-block')
    //   setClassEditorParaphrase('')

    //   return paraphraseSentence({ text: cheerio.load(sentence).text(), sentence, domainOrigin: getDomainOrigin() })
    //     .then(response => {
    //     // se acontecer algum erro, simplesmente a sentença não terá as tags span, vai continuar normal
    //       if (response === "error") return

    //       if (response && response.synonyms) setSynonyms(synonyms => Object.assign(synonyms, response.synonyms))

    //       response.text = fixEntityEncoding(response.text)
    //       response.sentence = fixEntityEncoding(response.sentence)

    //       const $ = cheerio.load(response.paraphrase, null, false)
    //       const index = Math.floor(Math.random() * (9999999999 - 1111111111 + 1) + 1111111111)

    //       $('.original').addClass(`paraphrase-${index}`)
    //       $('.paraphrase').attr('id', `paraphrase-${index}`)

    //       const original = $.html($('.original'))
    //       const paraphrase = $.html($('.paraphrase'))

    //       let paraphrasedText = editorParaphrased.current.getContent(editorParaphrased.current.getBody())
    //       let originalText = editorOriginal.current.getContent(editorOriginal.current.getBody())

    //       if (paraphrasedText.includes(response.text)) paraphrasedText = paraphrasedText.replace(response.text, paraphrase)
    //       else paraphrasedText = paraphrasedText.replace(response.sentence, paraphrase)
    //       if (originalText.includes(response.text)) originalText = originalText.replace(response.text, original)
    //       else originalText = originalText.replace(response.sentence, original)

    //       if (paraphrasedText.includes(response.text) === false
    //           && paraphrasedText.includes(response.sentence) === false
    //           && originalText.includes(response.text) === false
    //           && originalText.includes(response.sentence) === false
    //       ) {
    //         sentencesNoRewrited.push(response.text || response.sentence || '')
    //         return
    //       }

    //       editorOriginal.current.setContent(originalText)
    //       editorParaphrased.current.setContent(paraphrasedText)

    //       diffTextOnChangeText({ editorOriginal, editorParaphrased, paraphraseID: `paraphrase-${index}` })
    //     })
    // }, { concurrency: Infinity })
    //   .then(async () => {
    //     // REMOVE TODOS SPAN DE CURSOR ADICIONADOS EM TODAS SENTENÇAS
    //     const paraphrasedText = editorParaphrased.current.getContent(editorParaphrased.current.getBody())
    //     const $ = cheerio.load(paraphrasedText, null, false)
    //     $("#cursor").remove()
    //     editorParaphrased.current.setContent($.html())

    //     editorParaphrased.current.dom.removeClass(editorParaphrased.current.dom.select('body'), 'rewriting')
    //     NotificationManager.remove(NotificationManager.listNotify[0])
    //     setShowButtonParaphrase(false)
    //     editorParaphrased.current.setMode('design')
    //     editorOriginal.current.setMode('readonly')

    //     editorOriginal.current.iframeElement.contentWindow.scrollTo(0, 0)
    //     editorParaphrased.current.iframeElement.contentWindow.scrollTo(0, 0)

    //     if (sentencesNoRewrited.length > 0) {
    //       NotificationManager.error(`Pode ser que uma ou mais sentenças não foram reescritas corretamente.
    //       As partes não reescritas podem apresentar vestígios de plágio.`)
    //       // Sentry.captureException(e)
    //       console.log('sentencesNoRewrited:', sentencesNoRewrited)
    //       console.log('TEXTO:', text)
    //       // Sentry.captureMessage(`ERRO: SENTENÇAS NÃO REESCRITA`)
    //     }

    //     // console.log('ip1:', ip)
    //     await axios.post(`https://q1f8kd88uc.execute-api.us-east-1.amazonaws.com/prod/daily-use`, {
    //       ip, increment: true, email, countWords
    //     })

    //     if (!trial) {
    //       try {
    //         await axios.post(`https://q1f8kd88uc.execute-api.us-east-1.amazonaws.com/prod/usage`, {
    //           userID, email, ferramenta: "reescrever", countWords
    //         })
    //       } catch (error) {
    //         console.log('error:', error)
    //       }
    //     }
    //   })
    //   .catch((error) => {
    //     NotificationManager.remove(NotificationManager.listNotify[0])
    //     NotificationManager.error(`Erro desconhecido: ${error}`, '', 0)
    //   })

  }

  const onGetRewritedText = async (data, userID, email, ip) => {

    setClassEditorOriginal('d-none d-md-block')
    setClassEditorParaphrase('')

    data = JSON.parse(data)

    // SE TIVER HIGHLIGHTED, ENTÃO É PORQUE CLIENTE PEDIU PARA REESCREVER SOMENTE UM PARÁGRAFO (USOU OPÇÃO REFRASEAR)
    const spanEditorOriginalHighlighted = editorOriginal.current.iframeElement.contentWindow.document.querySelector('.highlighted-paraphrase')
    const spanEditorParaphrasedHighlighted = editorParaphrased.current.iframeElement.contentWindow.document.querySelector('.highlighted-paraphrase')
    if (spanEditorParaphrasedHighlighted) {
      const paraphraseClicked = spanEditorParaphrasedHighlighted.id
      // console.log("paraphraseClicked: ", paraphraseClicked);
      
      editorParaphrased.current.iframeElement.contentWindow.document.querySelector(`#${paraphraseClicked}`).textContent =  data.textRewrited
      
      
      spanEditorOriginalHighlighted.classList.remove('highlighted-paraphrase')
      spanEditorParaphrasedHighlighted.classList.remove('highlighted-paraphrase')
      
      const hasRephrasing = editorParaphrased.current.iframeElement.contentWindow.document.querySelector('.rephrasing')
      hasRephrasing.classList.remove('rephrasing')
      
      setShowButtonParaphrase(false)
      editorParaphrased.current.setMode('design')
      
      diffTextOnChangeText({ editorOriginal, editorParaphrased, paraphraseID: paraphraseClicked })
      
      // REMOVER TODAS OCORRÊNCIA DO SPAN CURSOR NO TEXTO
      editorParaphrased.current.setContent(editorParaphrased.current.getBody().innerHTML.replace(/<span id="cursor" class="added"><\/span>/g, ''));
      return
    }

    
    // console.log('data:', data)
    // if (data && data.textRewrited) data.textRewrited = data.textRewrited.replace(/<\/p>\n<p>/g, '</p><p>')
    // if (data && data.textRewrited) data.textRewrited = data.textRewrited.replace(/\n/g, '<br/>')
    // editorParaphrased.current.setContent(data.textRewrited)

    const ATIVAR_SINONIMOS = false

    if (ATIVAR_SINONIMOS === true) {
      await paraphraseSentence({ text: data.originalText, sentence: data.textRewrited, domainOrigin: getDomainOrigin() })
      .then(response => {
  
        if (response === "error") return
  
        if (response && response.synonyms) setSynonyms(synonyms => Object.assign(synonyms, response.synonyms))
  
          response.text = fixEntityEncoding(response.text)
          response.sentence = fixEntityEncoding(response.sentence)
  
          const $ = cheerio.load(response.paraphrase, null, false)
          let index = Math.floor(Math.random() * (9999999999 - 1111111111 + 1) + 1111111111)
          if (editorParaphrased.current.iframeElement.contentWindow.document.querySelector('.highlighted-paraphrase')) {
            index = editorParaphrased.current.iframeElement.contentWindow.document.querySelector('.highlighted-paraphrase').id
          }
  
          $('.original').addClass(`paraphrase-${index}`)
          $('.paraphrase').attr('id', `paraphrase-${index}`)
  
          const original = $.html($('.original'))
          const paraphrase = $.html($('.paraphrase'))
  
          let paraphrasedText = editorParaphrased.current.getContent(editorParaphrased.current.getBody())
          let originalText = editorOriginal.current.getContent(editorOriginal.current.getBody())
  
          if (paraphrasedText.includes(response.text)) paraphrasedText = paraphrasedText.replace(response.text, paraphrase)
          else paraphrasedText = paraphrasedText.replace(response.sentence, paraphrase)
          if (originalText.includes(response.text)) originalText = originalText.replace(response.text, original)
          else originalText = originalText.replace(response.sentence, original)
  
          // if (paraphrasedText.includes(response.text) === false
          //     && paraphrasedText.includes(response.sentence) === false
          //     && originalText.includes(response.text) === false
          //     && originalText.includes(response.sentence) === false
          // ) {
          //   sentencesNoRewrited.push(response.text || response.sentence || '')
          //   return
          // }
  
          editorOriginal.current.setContent(originalText)
          editorParaphrased.current.setContent(paraphrasedText)

          diffTextOnChangeText({ editorOriginal, editorParaphrased, paraphraseID: `paraphrase-${index}` })
      })
    }

    if (ATIVAR_SINONIMOS === false) {
      const index = Math.floor(Math.random() * (9999999999 - 1111111111 + 1) + 1111111111)

      let paraphrasedText = editorParaphrased.current.getContent(editorParaphrased.current.getBody())
      let originalText = editorOriginal.current.getContent(editorOriginal.current.getBody())

      if (paraphrasedText.includes(data.originalText)) paraphrasedText = paraphrasedText.replace(data.originalText, `<span id="paraphrase-${index}" class="paraphrase">${data.textRewrited}</span>`)
      if (originalText.includes(data.originalText)) originalText = originalText.replace(data.originalText, `<span class="original paraphrase-${index}">${data.originalText}</span>`)

      editorParaphrased.current.setContent(paraphrasedText)
      editorOriginal.current.setContent(originalText)

      diffTextOnChangeText({ editorOriginal, editorParaphrased, paraphraseID: `paraphrase-${index}` })
    }

    totalParagraphsRewrited = totalParagraphsRewrited + 1

    

    // editorOriginal.current.setContent(data.leftSentenceWithDiff)
    // ENTRA NESSE IF SOMENTE APÓS REESCREVER TODOS PARÁGRAFOS
    if (totalParagraphsRewrited === totalParagraphsToRewrite) {

      // REMOVER TODAS OCORRÊNCIA DO SPAN CURSOR NO TEXTO
      editorParaphrased.current.setContent(editorParaphrased.current.getBody().innerHTML.replace(/<span id="cursor" class="added"><\/span>/g, ''));

      editorParaphrased.current.dom.removeClass(editorParaphrased.current.dom.select('body'), 'rewriting')
      NotificationManager.remove(NotificationManager.listNotify[0])
      setShowButtonParaphrase(false)
      editorParaphrased.current.setMode('design')
      // editorOriginal.current.setMode('readonly')
  
      editorOriginal.current.iframeElement.contentWindow.scrollTo(0, 0)
      editorParaphrased.current.iframeElement.contentWindow.scrollTo(0, 0)

      totalParagraphsRewrited = 0

      // diffTextOnChangeText({ editorOriginal, editorParaphrased })

      const countWords = editorOriginal.current.plugins.wordcount.getCount()
      console.log("countWords: ", countWords);

      // console.log('ip1:', ip)
      // TABELA USO-GRATIS-REESCREVER
      // console.log('ipppppp:', ip)
      await axios.post(`https://q1f8kd88uc.execute-api.us-east-1.amazonaws.com/prod/daily-use`, {
        ip, increment: true, email, tool: "reescrever", countWords
      })

      // TABELA USO-FERRAMENTAS
      if (!trial) {
        try {
          await axios.post(`https://q1f8kd88uc.execute-api.us-east-1.amazonaws.com/prod/usage`, {
            userID, email, ferramenta: "reescrever", countWords
          })
        } catch (error) {
          console.log('error:', error)
        }
      }
    }


    
  }

  const onTextSubmit = () => {

    // NÃO CONSEGUIU CAPTURAR O IP DO CLIENTE, E É UM CLIENTE GRÁTIS
    // ENTÃO NÃO PERMITE USAR A FERRAMENTA, SENÃO USARIA GRÁTIS SEM LIMITES
    if (!(ip) && usuarioPagante === false) return

    if (isEmpty(editorOriginal.current.getContent())) {
      NotificationManager.error('Insira um texto antes de clicar no botão')
      return
    }

    // Quando o usuário digita espaços diretamente no TinyMCE, ele troca por &nbsp; porém isso é ruim
    // para o diff, pois em alguns casos pode falar que foi alterado algo quando não foi
    // Portanto, essa linha abaixo REMOVE &nbsp; do texto original que foi digitado
    // Todos &nbsp; que tinham ao colar o texto foram removidos anteriormente, no PastePostProcess
    editorOriginal.current.setContent(editorOriginal.current.getContent().replace(/\u00a0/g, " "))

    onSubmitText(editorOriginal.current.getContent())
  }

  const newParaphrase = () => {
    editorParaphrased.current.setContent('')
    editorOriginal.current.setContent('')
    editorParaphrased.current.setMode('readonly')
    editorOriginal.current.setMode('design')
    setShowButtonParaphrase(true)
    editorOriginal.current.focus()

    setClassEditorOriginal('')
    setClassEditorParaphrase('d-none d-md-block')
  }

  const buttonText = {
    synonymous: 'Generate text',
    spintax: 'Generate spintax',
    paraphrase: 'Generate paraphrase',
    summarize: 'Generate summary'
  }

  return (
    <Card className="h-100">
      <CardBody>
        <RephraseTools
          editorOriginal={editorOriginal}
          editorParaphrased={editorParaphrased}
          paraphrases={paraphrases}
          setParaphrases={setParaphrases}
          setSynonymsRephrase={setSynonymsRephrase}
        />
        <Row>
          <Colxx md="6" xl="6" xxl="6" lg="6" className={`mb-4 ${classEditorOriginal}`}>
            <AvForm
              className="av-tooltip tooltip-label-bottom w-100"
              onSubmit={onTextSubmit}
              ref={formRef}
            >
              <Editor
                ref={editorOriginal}
                initialValue={initialValueOriginal}
                init={{
                  language: "pt_BR",
                  branding: false,
                  body_id: 'editorOriginal',
                  placeholder: `Cole seu texto aqui. Depois clique no botão Reescrever. Para finalizar, revise o texto para garantir total legibilidade e autênticidade.`,
                  entity_encoding: 'raw',
                  entities: 'nbsp,160',
                  auto_focus: true,
                  height: 430,
                  width: '100%',
                  menubar: false,
                  plugins: [
                    'advlist autolink lists link image charmap print preview anchor',
                    'searchreplace visualblocks code fullscreen',
                    'insertdatetime media table paste code help wordcount code noneditable nonbreaking'
                  ],
                  toolbar: 'formatselect | alignleft aligncenter alignright alignjustify | bullist numlist',
                  fullscreen_native: true,
                  browser_spellcheck: true,
                  contextmenu: false,
                  elementpath: false,
                  invalid_elements: "div",
                  forced_root_block: 'p',
                  nonbreaking_wrap: false,
                  content_css: '/assets/css/paraphrase2.css',
                  setup: (editor) => {
                    editor.on('init', () => {
                      editorOriginal.current = editor
                      // editorOriginal.current.getWin().onscroll = () => {
                      //   // bloqueia o scroll (deixa o scroll igual do editorParaphrased sempre que tentar mexer, dando a impressão que está bloqueado)
                      //   if (!isEmpty(editorParaphrased.current.getContent())) editorOriginal.current.iframeElement.contentWindow.scrollTo(0, editorParaphrased.current.dom.getViewPort(editorParaphrased.current.getWin()).y)
                      // }
                    })

                    let showLimit = true
                    let showLimit2000 = true
                    const countWords = (e) => {
                      if (trial2) {
                        const allText = e.content + window.tinymce.activeEditor.getContent({ format: "text" })
                        if (allText.split(" ").length > 300 && showLimit) {
                          NotificationManager.error(messages['The limit is 300 words for the free plan'], '', 0)
                          showLimit = false
                        } else if (allText.split(" ").length < 300) {
                          NotificationManager.remove(NotificationManager.listNotify[0])
                          showLimit = true
                        }
                      } else {
                        if (trial2 === false) {
                          const allText = e.content + window.tinymce.activeEditor.getContent({ format: "text" })
                          if (allText.split(" ").length > 2000 && showLimit2000) {
                            NotificationManager.error(messages['The limit is 2000 words for paid plans'], '', 0)
                            showLimit2000 = false
                          } else if (allText.split(" ").length < 2000) {
                            NotificationManager.remove(NotificationManager.listNotify[0])
                            showLimit2000 = true
                          }
                        } else {
                          NotificationManager.remove(NotificationManager.listNotify[0])
                          showLimit = true
                          showLimit2000 = true
                        }
                      }
                    }

                    editor.on('PastePreProcess', (e) => {
                      // console.log('e.content:', e.content)
                      e.content = e.content
                        .replace(/<\/?a[^>]*>/g, '')
                        .replace(/<div>/g, '<p>')
                        .replace(/<\/div>/g, '</p>')
                        .replace(/<\/?span[^>]*>/g, '')
                        .replace(/​/g, ' ') // Remove espaço U+200B
                        .replace(/([^.][^.!?:”"')\]])<[Bb][Rr][^>]*>([^A-Z]|[A-Z])/gm, "$1 $2")
                      // console.log('e.content:', e.content)
                    });

                    editor.on('PastePostProcess', (e) => {
                      // REMOVE TODOS &nbps; ao colar o texto
                      e.node.innerHTML = e.node.innerHTML.replace(/&nbsp;/ig, " ")
                        .replace(/<strong>|<\/strong>/g, '')
                        .replace(/<b>|<\/b>/g, '')
                        .replace(/<em>|<\/em>/g, '')
                        .replace(/<u>|<\/u>/g, '')
                        .replace(/<i>|<\/i>/g, '')
                        .replace(/<sup>|<\/sup>/g, '')
                        // regex abaixo remove as tags com atributos <tag eatributosaqui>
                        .replace(/<\/?span[^>]*>/g, '')
                        .replace(/<\/?strong[^>]*>/g, ' ')
                        .replace(/<\/?b[^>]*>/g, ' ')
                        .replace(/<\/?em[^>]*>/g, ' ')
                        .replace(/<\/?u[^>]*>/g, ' ')
                        .replace(/<\/?i[^>]*>/g, ' ')
                        .replace(/<\/?sup[^>]*>/g, ' ')
                    });

                    editor.on('Paste Change input Undo Redo Keydown Keyup', (e) => {
                      countWords(e)
                    })
                  }
                }}
              />

              <Row>
                <Colxx xl="12" lg="12" className="mb-4 pt-4">
                  <div className="position-absolute l-0 ml-3">
                    {!showButtonParaphrase && (
                      isEmpty(summarizedText)
                        ? (
                          <StateButton
                            block
                            color="primary"
                            className="text-uppercase mt-4"
                            onClick={toggleModalBack}
                          >
                            <IntlMessages id="NEW TEXT" />
                          </StateButton>
                        )
                        : (
                          <StateButton
                            block
                            color="primary"
                            className="text-uppercase mt-4"
                            onClick={() => { history.push(`/app/summary2/${email}`) }}
                          >
                            NOVO RESUMO
                          </StateButton>
                        )
                    )}
                  </div>

                  <div className="position-absolute r-0 mr-3">
                    {showButtonParaphrase && (
                      <StateButton
                        block
                        formRef={formRef.current}
                        color="primary"
                        className="text-uppercase mt-4"
                        // disabled={!(ip) && usuarioPagante === false}
                        onClick={() => {
                          if (!(ip) && usuarioPagante === false) {
                            toggleModalBackIPVazio()
                          }
                        }}
                      >
                        <IntlMessages id={buttonText[tool]} />
                      </StateButton>
                    )}
                  </div>
                </Colxx>
              </Row>

            </AvForm>
          </Colxx>
          <Colxx md="6" xl="6" xxl="6" lg="6" className={`mb-4 ${classEditorParaphrase}`}>
            <Editor
              ref={editorParaphrased}
              initialValue={initialValueParaphrased}
              init={{
                language: "pt_BR",
                branding: false,
                body_id: 'editorParaphrased',
                entity_encoding: 'raw',
                entities: 'nbsp,160',
                height: 430,
                width: '100%',
                menubar: false,
                plugins: [
                  'advlist autolink lists link image charmap print preview anchor',
                  'searchreplace visualblocks code fullscreen',
                  'insertdatetime media table paste code help wordcount code noneditable nonbreaking'
                ],
                toolbar: 'original copySentence rephrase formatselect | alignleft aligncenter alignright alignjustify | bullist numlist',
                fullscreen_native: true,
                browser_spellcheck: true,
                contextmenu: false,
                elementpath: false,
                invalid_elements: "div",
                forced_root_block: 'p',
                nonbreaking_wrap: false,
                content_css: '/assets/css/paraphrase2.css',
                setup: (editor) => {
                  // Essa opção abaixo desabilita o Ctrl + Z
                  // editor.on('BeforeAddUndo', () => false)

                  editor.ui.registry.addButton('copySentence', {
                    icon: 'copy',
                    tooltip: 'Copiar Sentença',
                    disabled: true,
                    onAction() {
                      copyParaphraseToClipboard(editorParaphrased)
                    }
                  })

                  editor.ui.registry.addButton('original', {
                    icon: 'rotate-left',
                    tooltip: 'Sentença Original',
                    disabled: true,
                    onAction() {
                      undoPhrase(editorOriginal, editorParaphrased)
                    }
                  })

                  editor.ui.registry.addButton('rephrase', {
                    icon: 'reload',
                    tooltip: 'Refrasear',
                    disabled: true,
                    onAction() {
                      rephraseSentence(editorOriginal, editorParaphrased, paraphrases, setParaphrases, setSynonymsRephrase, clientRef)
                    }
                  })

                  editor.on('init', () => {
                    editor.setMode('readonly')

                    editorParaphrased.current = editor
                    editorParaphrased.current.getWin().onscroll = () => {
                      const editorOriginalScrollHeight = editorOriginal.current.iframeElement.contentWindow.document.scrollingElement.scrollHeight
                      const editorOriginalClientHeight = editorOriginal.current.iframeElement.contentWindow.document.scrollingElement.clientHeight
                      const editorOriginalTop = editorOriginalScrollHeight - editorOriginalClientHeight

                      const editorParaphrasedScrollHeight = editorParaphrased.current.iframeElement.contentWindow.document.scrollingElement.scrollHeight
                      const editorParaphrasedClientHeight = editorParaphrased.current.iframeElement.contentWindow.document.scrollingElement.clientHeight
                      const editorParaphrasedTop = editorParaphrasedScrollHeight - editorParaphrasedClientHeight

                      const editorParaphrasedYoffsetHeight = editorParaphrased.current.iframeElement.contentWindow.document.scrollingElement.offsetHeight
                      const editorOriginalYoffsetHeight = editorOriginal.current.iframeElement.contentWindow.document.scrollingElement.offsetHeight

                      const editorParaphrasedYHeightScroll = editorParaphrased.current.dom.getViewPort(editorParaphrased.current.getWin()).y
                      let scroll = 0
                      if (editorOriginalYoffsetHeight > editorParaphrasedYoffsetHeight) {
                        // console.log('aqui1', editorOriginalYoffsetHeight, editorParaphrasedYoffsetHeight, editorParaphrased.current.dom.getViewPort(editorParaphrased.current.getWin()).y)
                        scroll = (editorOriginalTop / editorParaphrasedTop) * editorParaphrasedYHeightScroll
                      } else {
                        // TODO: testar pra ver se isso realmente funciona caso o editor original for menor que o editor parafraseado
                        scroll = (editorParaphrasedTop / editorOriginalTop) * editorParaphrasedYHeightScroll
                      }

                      editorOriginal.current.iframeElement.contentWindow.scrollTo(0, scroll)
                    }
                  })

                  editor.on('click', (event) => {
                    if (event.target.id.includes('synonym')) {
                      // saber se possui seleção ou não é importante caso for usar comandos como CTRL+C/V/X, etc...
                      // corrige o bug de recortar textos selecionados (era adicionar o cursor no lugar da seleção)
                      const { startOffset, endOffset } = editorParaphrased.current.selection.getRng()

                      if (event.ctrlKey === false && startOffset === endOffset) {
                        editorParaphrased.current.dom.remove('cursor') // remove todos cursor que possa existir
                        editorParaphrased.current.selection.setContent(spanCursor) // adiciona o cursor
                      }

                      if (startOffset === endOffset) {
                        addSynonymsList(editorParaphrased, editorOriginal, synonyms2, event)
                        addHighlightedParaphrase({ editorParaphrased, editorOriginal })
                      }
                    } else {
                      removeSynonymsList(editorParaphrased)
                      removeRephraseTools(editorParaphrased)
                    }

                    if (isEmpty(event.target.dataset.index) && (event.target.id.includes('paraphrase') || isEmpty(event.target.id))) {
                      addHighlightedParaphrase({ editorParaphrased, editorOriginal })
                    }
                  })

                  const keysArrow = ['ArrowRight', 'ArrowUp', 'ArrowDown', 'ArrowLeft']
                  const keys = ['ArrowRight', 'ArrowUp', 'ArrowDown', 'ArrowLeft', 'Alt', 'Dead']
                  // const keysToSetSpan = ['Backspace', 'Delete']

                  editor.on('keyup', (event) => {
                    // se a caixa de sinônimos estiver aberta ao apertar ESC, ela é fechada
                    if (event.key === 'Escape') {
                      removeSynonymsList(editorParaphrased)
                      removeRephraseTools(editorParaphrased)
                    }

                    // se mover o cursor de lugar com as setas, adiciona highlighted na paráfrase que possui o cursor
                    if (keysArrow.includes(event.key)) addHighlightedParaphrase({ editorParaphrased, editorOriginal })

                    // saber se possui seleção ou não é importante caso for usar comandos como CTRL+C/V/X, etc...
                    // corrige o bug de recortar textos selecionados (era adicionar o cursor no lugar da seleção)
                    const { startOffset, endOffset } = editorParaphrased.current.selection.getRng()

                    if (event.ctrlKey === false && startOffset === endOffset) {
                      editorParaphrased.current.dom.remove('cursor') // remove todos cursor que possa existir
                      editorParaphrased.current.selection.setContent(spanCursor) // adiciona o cursor
                      if (!keys.includes(event.key) && event.key !== 'Escape') diffTextOnChangeText({ editorOriginal, editorParaphrased })
                    }
                  })


                }
              }}
            />

            {/* Mostra abaixo 800px, ESCONDE O ORIGINAL */}
            <Row className="mb-4 mt-4 d-block d-md-none">
              <Colxx xl="6" xxl="6" lg="6">
                <div className="position-absolute l-0 ml-3">
                  {!showButtonParaphrase && (
                    isEmpty(summarizedText)
                      ? (
                        <StateButton
                          block
                          color="primary"
                          className="text-uppercase mt-4"
                          onClick={toggleModalBack}
                        >
                          <IntlMessages id="NEW TEXT" />
                        </StateButton>
                      )
                      : (
                        <StateButton
                          block
                          color="primary"
                          className="text-uppercase mt-4"
                          onClick={() => { history.push(`/app/summary2/${email}`) }}
                        >
                          NOVO RESUMO
                        </StateButton>
                      )
                  )}
                </div>
              </Colxx>

              <Colxx xl="6" xxl="6" lg="6">
                <div className="position-absolute r-0 mr-3">
                  {!showButtonParaphrase && (
                  <StateButton
                    block
                    color="outline-primary"
                    className="text-uppercase mt-4"
                    onClick={() => { copyTextToClipboard(editorParaphrased) }}
                  >
                    <IntlMessages id="Copy" />
                  </StateButton>
                  )}
                </div>
              </Colxx>
            </Row>

            {/* Mostra acima 800px, MOSTRA O ORIGINAL */}
            <Row className="mb-4 mt-4 d-none d-md-block">
              <Colxx xl="12" lg="12" className="mb-4 pt-4 d-none" />

              <Colxx xl="12" lg="12" className="mb-4 mt-4">
                <div className="position-absolute r-0 mr-3">
                  {!showButtonParaphrase && (
                    <StateButton
                      block
                      color="outline-primary"
                      className="text-uppercase mt-4"
                      onClick={() => { copyTextToClipboard(editorParaphrased) }}
                    >
                      <IntlMessages id="Copy" />
                    </StateButton>
                  )}
                </div>
              </Colxx>
            </Row>
          </Colxx>
        </Row>

        <Modal
          isOpen={modalBack}
          toggle={toggleModalBack}
        >
          <ModalHeader toggle={toggleModalBack}>
            <IntlMessages id="Are you sure?" />
          </ModalHeader>
          <ModalBody>
            <p>
              <IntlMessages id="Make sure you have saved text before proceeding. It will not be possible to recover it." />
            </p>
          </ModalBody>
          <ModalFooter>
            <StateButton
              onClick={() => {
                newParaphrase()
                toggleModalBack()
              }}
              color="primary"
            >
              <IntlMessages id="Yes" />
            </StateButton>
            {' '}
            <StateButton color="outline-primary" onClick={toggleModalBack}>
              <IntlMessages id="No" />
            </StateButton>
          </ModalFooter>
        </Modal>

        {/* MODAL IP NÃO CAPTURADO */}
        <Modal
          isOpen={modalBackIP}
          toggle={toggleModalBackIPVazio}
        >
          <ModalHeader toggle={toggleModalBackIPVazio}>
            {/* <IntlMessages id="Are you sure?" /> */}
            Uma parte essencial do sistema não está sendo carregada adequadamente
          </ModalHeader>
          <ModalBody>
            <p>
              {/* <IntlMessages id="Make sure you have saved text before proceeding. It will not be possible to recover it." /> */}
              Se você possui uma conta paga e está visualizando esta mensagem, é provável que você não esteja autenticado em sua conta. Portanto, ao fazer o login, essa mensagem será removida e você conseguirá reescrever corretamente.
              {' '}
              <strong><a href="https://reescrever.app/login/">Clique aqui para efetuar o login</a></strong>
              .
            </p>
            <p>
              Se você estiver acessando por um dispositivo móvel e já estiver devidamente autenticado, mas ainda assim visualizar essa mensagem, é provável que esteja usando um navegador integrado que não armazena o cache do login. Para solucionar esse problema, acesse nosso site pelo navegador Google Chrome ou Mozilla Firefox, pois esses navegadores armazenam o cache do login e permitirão que você utilize normalmente.
            </p>
            <p>Caso necessite de auxílio ou possua alguma dúvida, estamos disponíveis para ajudar.</p>
            {/* <p>Caso você seja um usuário gratuito, veja possíveis causas e soluções:</p>
            <p>
              <ul>
                <li>Seu navegador está bloqueando: experimente utilizar outro navegador.</li>
                <li>Seu antivírus está bloqueando: desabilite temporariamente para testar. Se o sistema funcionar corretamente, é possível que o antivírus esteja causando o bloqueio. Nesse caso, procure orientações específicas de como desbloquear o nosso site, mantendo o antivírus ativo.</li>
                <li>Sua conexão de internet está bloqueando: tente utilizar uma rede diferente, como Wi-Fi ou 3G/4G. Se estiver usando Wi-Fi, tente usar 3G/4G e vice-versa.</li>
                <li>Se nenhuma das soluções anteriores funcionar, considere adquirir uma assinatura paga.</li>
              </ul>
            </p>
            <p>Caso necessite de auxílio ou possua alguma dúvida, estamos disponíveis para ajudar. Nos chame no Whatsapp.</p> */}

          </ModalBody>
        </Modal>

      </CardBody>
    </Card>
  )
}
export default injectIntl(EditorsParaphrase)
